module.exports = __webpack_public_path__ + "2039c29e66abef44e065207ee34356c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2058_teaser_image.jpg
// module id = 581
// module chunks = 0